<template>
  <v-navigation-drawer
    id="default-drawer"
    v-model="drawer"
    :dark="dark"
    :right="$vuetify.rtl"
    :src="drawerImage ? image : ''"
    :mini-variant.sync="mini"
    mini-variant-width="80"
    app
    width="260"
  >
    <template
      v-if="drawerImage"
      #img="props"
    >
      <v-img
        :key="image"
        :gradient="gradient"
        v-bind="props"
      />
    </template>

    <div class="px-2">
      <default-drawer-header />

      <v-divider class="mx-3 mb-2" />

      <default-list
        :items="items"
      />
    </div>

    <template #append>
      <div class="pa-4 text-center">
        <!--<app-btn
          class="text-none mb-4"
          color="white"
          href="https://vuetifyjs.com"
          small
          text
        >
          Documentation
        </app-btn>-->

        <app-btn
          v-show="vshow"
          block
          class="text-none"
          color="secondary"
          target="_blank"
          href="http://work.zhiweb.cn/index.php?m=user&c=no&uuid=5712ca50-4529-46b2-af99-a97b9931990d"
        >
          <v-icon left>
            mdi-animation
          </v-icon>

          案例平台
        </app-btn>
      </div>
    </template>

    <div class="pt-12" />
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { get, sync } from 'vuex-pathify'
  import axios from 'axios'
  export default {
    name: 'DefaultDrawer',
    components: {
      DefaultDrawerHeader: () => import(
        /* webpackChunkName: "default-drawer-header" */
        './widgets/DrawerHeader'
      ),
      DefaultList: () => import(
        /* webpackChunkName: "default-list" */
        './List'
      ),
    },

    data: () => ({
      roles: '',
      userInfo: [],
      vshow: false,
    }),

    computed: {
      ...get('user', [
        'dark',
        'gradient',
        'image',
      ]),
      ...get('app', [
        'items',
        'version',
      ]),
      ...sync('app', [
        'drawer',
        'drawerImage',
        'mini',
      ]),
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        // console.log(this.items)
        // console.log(this.items.length)
        // 获取来源列表
        if (this.items.length === 0) {
          this.$router.go(0)
        }
        // 获取用户列表
        axios
          .get(process.env.VUE_APP_BASE_API + '/admins/profile')
          .then(response => {
            if (response.data.code === 20000) {
              this.userInfo = response.data.data
              this.roles = this.userInfo.roles.trim()
              if (this.roles !== 'sem') {
                this.vshow = true
              }
              // alert(this.vshow)
              // console.log(this.roles)
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
  }
</script>

<style lang="sass">
#default-drawer
  .v-list-item
    margin-bottom: 8px

  .v-list-item::before,
  .v-list-item::after
    display: none

  .v-list-group__header__prepend-icon,
  .v-list-item__icon
    margin-top: 12px
    margin-bottom: 12px
    margin-left: 4px

  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important
</style>
